<!-- 工作台 -->
<template>
    <div id class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="container">
            <div class="containerBox">
                <div class="search">
                    <div class="searchBox">
                        <span class="searchtitle">VIN码/车架号</span>
                        <el-autocomplete
                            class="vin-input"
                            clearable
                            v-model.trim="vin"
                            v-filter-special-char="vin"
                            :fetch-suggestions="querySearchAsync"
                            placeholder="请输入17位车架号码"
                            @select="getTableData"
                        ></el-autocomplete>
                        <el-button icon="el-icon-search" class="btn-primary" @click="getTableData">查询</el-button>
                        <uploadImgToOCR ref="uploadImgToOCR" :limit="1" @getVINTxt="translateText"></uploadImgToOCR>
                    </div>
                    <div class="searchBox vinCheckMsg">
                        <div class="searchHistory" v-if="vinCheckMsg">
                            {{ vinCheckMsg }}
                        </div>
                    </div>
                </div>
                <div class="search-result" v-if="resultShow">
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="firstkey">品牌</div>
                            <div class="firstvalue">
                                <span>{{ vinData.BrandName }}</span>
                                &nbsp;&nbsp;
                                <img :src="downloadUrl + vinData.BrandLogo" alt :onerror="defaultImg" v-if="vinData.BrandLogo" />
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="firstkey">车系</div>
                            <div class="firstvalue">
                                <span>{{ vinData.CarLine }}</span>
                                &nbsp;&nbsp;
                                <img :src="downloadUrl + vinData.AutoImg" alt :onerror="defaultImg" v-if="vinData.AutoImg" />
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="firstkey">生产商</div>
                            <div class="firstvalue">
                                <span>{{ vinData.Manufacturer }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">车型名称</div>
                            <div class="value">
                                <span>{{ vinData.ModelName }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">年款</div>
                            <div class="value">
                                <span>{{ vinData.ModelYear }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">座位数量</div>
                            <div class="value">
                                <span>{{ vinData.SeatNum }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">发动机</div>
                            <div class="value">
                                <span>{{ vinData.EngineType }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">生产年份</div>
                            <div class="value">
                                <span>{{ vinData.MadeYear }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">功率/转速(kw/R)</div>
                            <div class="value">
                                <span>{{ vinData.Power }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">排量</div>
                            <div class="value">
                                <span>{{ vinData.OutputVolume }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">燃料</div>
                            <div class="value">
                                <span>{{ vinData.FuelType }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">发动机缸数</div>
                            <div class="value">
                                <span>{{ vinData.CylinderNumber }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">变速器</div>
                            <div class="value">
                                <span>{{ vinData.TransmissionType }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">气缸形式</div>
                            <div class="value">
                                <span>{{ vinData.CylinderForm }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">车身形式</div>
                            <div class="value">
                                <span>{{ vinData.CarBody }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">排放标准</div>
                            <div class="value">
                                <span>{{ vinData.EffluentStandard }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">驱动类型</div>
                            <div class="value">
                                <span>{{ vinData.DriveStyle }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">燃料标号</div>
                            <div class="value">
                                <span>{{ vinData.FuelNum }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">车门数量</div>
                            <div class="value">
                                <span>{{ vinData.DoorNum }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">档位数</div>
                            <div class="value">
                                <span>{{ vinData.GearsNum }}</span>
                            </div>
                        </div>
                        <div class="result-cell">
                            <div class="key">车辆类型</div>
                            <div class="value">
                                <span>{{ vinData.CarType }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="result-row">
                        <div class="result-cell">
                            <div class="key">车身重量</div>
                            <div class="value">
                                <span>{{ vinData.CarWeight }}</span>
                            </div>
                        </div>
                        <div class="result-cell" style="width: 100%">
                            <div class="key">销售名称</div>
                            <div class="value" style="width: 500px">
                                <span style="white-space::nowrap;text-align:center;overflow:hidden;">{{ vinData.SaleName }}</span>
                            </div>
                        </div>
                        <div class="result-cell" style="width: 0; display: none">
                            <div class="key"></div>
                            <div class="value">
                                <span></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="search-footer" v-if="resultShow">
                    <el-button class="btn-primary" @click="gotoMyShareGoods" v-if="vinData && vinData.AutoSerieId">我的网销商品</el-button>
                    <el-button class="btn-primary" @click="gotoQPSearch" v-if="vinData && vinData.AutoSerieId">对应配件库</el-button>
                    <el-button class="btn-primary" @click="gotoSupplieSearch" v-if="vinData && vinData.AutoSerieId">快速检索报价</el-button>
                    <p v-if="!(vinData && vinData.AutoSerieId)">该车型未找到匹配的配件库，可以试试联系客服哟</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import uploadImgToOCR from '@/components/common/uploadImgToOCR.vue';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb,
        uploadImgToOCR
    },
    data() {
        return {
            minHistory: [],
            maxHistory: [],
            historyList: [],
            resultShow: false,
            defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE + '"',
            downloadUrl: this.$util.QN_URL_BASE,
            vin: '',
            vins: '',
            vinData: {},
            timeout: null,
            vinCheckMsg: ''
        };
    },
    mounted() {
        let tempList = this.$util.getLocalStorage('VinSearchHistory');
        if (tempList) {
            let that = this;
            for (let i = 0; i < tempList.length; i++) {
                that.historyList.push({ value: tempList[i] });
            }
        }
        this.$util.setEnterEvent(this, this.$route.fullPath);
    },
    methods: {
        querySearchAsync(queryString, cb) {
            let _historyexis = this.historyList;
            let results = queryString ? _historyexis.filter(this.createStateFilter(queryString)) : _historyexis;
            cb(results);
        },
        createStateFilter(queryString) {
            return item => {
                if (item) {
                    let result = item.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1;
                    return result;
                }
            };
        },
        // 跳转到搜汽配
        gotoQPSearch() {
            let AutoSerieData = {
                AutoSerieId: this.vinData.AutoSerieId,
                Emission: this.vinData.OutputVolume,
                ProducedYear: this.vinData.ModelYear,
                Brand: this.vinData.BrandName,
                AutoSerieName: this.vinData.ModelName
            };
            this.$util.setLocalStorage('AutoSerieData', AutoSerieData); //传参到汽配快搜
            this.$router.push('/search/qpSearch');
        },
        gotoSupplieSearch() {
            let AutoSerieData = {
                AutoSerieId: this.vinData.AutoSerieId,
                Emission: this.vinData.OutputVolume,
                ProducedYear: this.vinData.ModelYear,
                Brand: this.vinData.BrandName,
                AutoSerieName: this.vinData.ModelName
            };
            this.$util.setLocalStorage('AutoSerieData', AutoSerieData);
            this.$router.push('/shareInventory/siGoodsSearch');
        },
        gotoMyShareGoods() {
            let AutoSerieData = {
                AutoSerieId: this.vinData.AutoSerieId,
                Emission: this.vinData.OutputVolume,
                ProducedYear: this.vinData.ModelYear,
                Brand: this.vinData.BrandName,
                AutoSerieName: this.vinData.ModelName
            };
            this.$util.setLocalStorage('AutoSerieData', AutoSerieData); //传参到汽配快搜
            this.$router.push('/shareInventory/myShareGoods');
        },
        searchData(item) {
            this.vin = item;
            this.getTableData();
        },
        // 提交数据
        getTableData() {
            this.vinCheckMsg = '';
            // LFV2A1157A3049579 车架号
            let reg = /^[a-zA-Z0-9]{17}$/;
            if (!reg.test(this.vin)) {
                this.$util.warningMsg('请输入正确的车架号');
                return;
            }

            if (this.historyList.findIndex(item => item.value === this.vin) == -1) {
                this.historyList.unshift({ value: this.vin });
                this.$util.setLocalStorage(
                    'VinSearchHistory',
                    this.historyList.map(item => {
                        return item.value;
                    })
                );
            }

            this.vinData = {};
            this.resultShow = false;
            this.$util
                .axiosGet({
                    url: '/api/Auto/GetAutoSerieVINDatas',
                    data: {
                        vin: this.vin
                    }
                })
                .then(res => {
                    if (res.data) {
                        let data = res.data;
                        this.vinData = data;
                        this.resultShow = true;
                    } else {
                        this.vinCheckMsg = '无搜索结果';
                        // this.$util.warningMsg("无搜索结果");
                    }
                    if (res.errmsg != 'ok') this.vinCheckMsg = res.errmsg;
                    else this.vinCheckMsg = '';
                })
                .catch(() => {});
        },
        translateText(txt) {
            if (txt) {
                this.vin = txt;
                this.getTableData();
            }
        }
    }
};
</script>
<style lang="less" scoped>
.vinCheckMsg {
    justify-content: left !important;
    width: 34% !important;
    padding-top: 10px !important;
    color: red;
}
.searchtitle {
    font-size: 18px;
    font-weight: bold;
    margin-right: 5px;
}
.search-result {
    width: 900px;
    margin: 0 auto;
    padding-top: 30px;
    border-bottom: 1px solid #dcdfe6;

    .result-row {
        display: flex;
        border-right: 1px solid #dcdfe6;
    }
    .result-cell {
        width: 50%;
        display: flex;
        align-items: center;
        border-top: 1px solid #dcdfe6;

        .firstkey {
            height: 60px;
            line-height: 60px;
            width: 100px;
            text-align: center;
            background-color: #f2f6fc;
            border-left: 1px solid #dcdfe6;
            padding-right: 10px;
        }
        .firstvalue {
            width: 200px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            border-left: 1px solid #dcdfe6;
            img {
                height: 50px;
            }
        }

        .key {
            height: 50px;
            line-height: 50px;
            width: 100px;
            text-align: center;
            background-color: #f2f6fc;
            border-left: 1px solid #dcdfe6;
            padding-right: 10px;
        }
        .value {
            width: 200px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            border-left: 1px solid #dcdfe6;
        }
    }
}
.search-footer {
    margin-top: 20px;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-evenly;
    align-content: center;
}
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
}
.containerBox {
    width: 1440px;
}
.search {
    width: 100%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-content: center;
    align-items: center;
}
.searchHistory {
    display: inline-flex;
    flex-flow: row-reverse;
}
.searchBox {
    width: 80%;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    justify-content: center;
    .vin-input {
        width: 400px;
        padding-right: 5px;
    }
}
</style>
